<template>
  <div>
    <el-card>
      <div class="header-card">
        <el-form label-width="100px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="用户名:" size="small" style="font-weight: 500">
                <el-input v-model="form.name" placeholder="请输入" :clearable="true" @keyup.enter.native="handleQueryClick"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="手机号:" size="small" style="font-weight: 500">
                <el-input v-model="form.phone" placeholder="请输入" :clearable="true"  @keyup.enter.native="handleQueryClick"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属机构:" size="small" style="font-weight: 500">
                <yl-cascader
                  :props="{ checkStrictly: true }"
                  :options="departments"
                  v-model="form.departmentId"
                  @change="handleDeptChange"
                  :show-all-levels="false"
                  clearable filterable>
                </yl-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" size="small" @click="handleQueryClick">查询</el-button>
              <el-button type="info" size="small" @click="resetConditions">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="add-member" style="float: left; padding: 15px 0px">
        <el-button type="primary" size="small" @click="handleAddClick" v-show="deptPower">
          新增成员
        </el-button>
      </div>

      <el-table v-loading="data.isLoading" :data="data.list" style="width: 100%;margin-top: 10px;" border fit
                size="small">
        <el-table-column align="center" prop="name" label="用户名"></el-table-column>
        <el-table-column align="center" prop="userId" label="手机号"></el-table-column>
        <el-table-column align="center" prop="gender" label="性别">
          <template slot-scope="scope">
            <span v-if="scope.row.gender === '1'">男</span>
            <span v-else-if="scope.row.gender === '0'">女</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="section" label="科室"></el-table-column>
        <el-table-column align="center" prop="birthDate" label="出生日期">
          <template slot-scope="scope">{{ scope.row.birthDate | dateFormat }}</template>
        </el-table-column>
        <el-table-column align="center" prop="educationCode" label="学历"></el-table-column>
        <el-table-column align="center" sortable prop="hospitalDate" label="来院时间">
          <template slot-scope="scope">{{ scope.row.hospitalDate | dateFormat }}</template>
        </el-table-column>
        <el-table-column align="center" prop="currentSectionPosition" label="当前科室职务"></el-table-column>
        <el-table-column align="center" prop="email" label="邮箱"></el-table-column>
        <el-table-column align="center" prop="majorDepartName" label="所属主机构"></el-table-column>
        <el-table-column align="center" sortable prop="lastUpdateInfoTime" label="最后更新时间">
          <template slot-scope="scope">{{ scope.row.lastUpdateInfoTime | datetimeFormat }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template  slot-scope="scope">
            <el-dropdown class="el-dropdown-link">
              <el-button class="el-icon-more identity-link" type="info" style="border: 0px;background-color: transparent"></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item  @click.native="handleViewClick(scope.row.userId)">
                  <i class="el-icon-view"></i>
                  <el-button style="border:0px !important;" type="text" size="small">查 看</el-button>
                </el-dropdown-item>
                <el-dropdown-item @click.native="handleUpdateClick(scope.row.userId)" v-show="deptPower">
                  <i class="el-icon-edit"></i>
                  <el-button style="border:0px !important;" type="text" size="small">修 改</el-button>
                </el-dropdown-item>
                <el-dropdown-item  @click.native="handleDeleteClick(scope.row)" v-show="deptPower">
                  <i class="el-icon-delete"></i>
                  <el-button style="border:0px !important;" type="text" size="small">删 除</el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination style="float: right; padding: 3px 0"
                       background layout="prev, pager, next" :page-size="20" :total="data.total"
                       @current-change="handlePageChange"
                       :current-page="data.currentPage">
        </el-pagination>
      </div>

      <el-dialog :visible.sync="dialog.isShow" class="spec-dialog" @close="handleCloseDialog" width="500px">
        <div class="dialog-title" slot="title">
          <template v-if="Object.is(dialog.dialogType,dialogType.add)">新增成员基本信息</template>
          <template v-if="Object.is(dialog.dialogType,dialogType.update)">编辑成员基本信息</template>
        </div>
        <el-form label-width="100px" v-loading="dialog.isLoading" :rules="rules" ref="ruleForm" :model="dialog.form">
          <el-form-item label="姓名：" prop="name">
            <el-input v-model="dialog.form.name" type="text" placeholder="请输入姓名" clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="userId">
            <el-input v-model="dialog.form.userId" type="text" placeholder="请输入手机号" clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="所属机构" prop="majorDepartId">
            <yl-cascader
              :options="departments"
              @change="handleDialogDeptChange"
              v-model="elementDeptId"
              :show-all-levels="false"
              filterable
              style="width: 100%">
            </yl-cascader>
          </el-form-item>
        </el-form>
        <template slot="footer" >
          <el-button @click="handleCommitDialog" size="small" type="primary" v-show="this.$route.query.flag != 'view'">提交</el-button>
          <el-button @click="handleCloseDialog" size="small" type="info">取消</el-button>
        </template>
      </el-dialog>
    </el-card>

    <!--动画加载组件-->
    <animation :loadingDataVisible="loadingDataVisible" :loadingText="'Loading'"></animation>

  </div>
</template>

<script>
import http from "@/utils/axios";
import {mapState} from "vuex";
import cookie from "@/utils/cookie";
import {Message} from "element-ui";
import animation from "@/components/loading/animation";
import {DIALOG_TYPE_ADD,DIALOG_TYPE_UPDATE} from '@/constants/constants';
import * as constantsRules from '@/constants/constantRules'


export default {
  name: "MemberList",
  components:{
    animation,
  },
  data() {
    return {
      elementDeptId:[],
      deptPower: true,
      superPower: true,
      departments: [], //部门数组
      form: {
        phone: '',
        name: '',
        departmentId: 0,
      },
      query: {
        phone: '',
        name: '',
        departmentId: 0,
      },
      data: {
        isLoading: false,
        list: [],
        pageNum: 1,
        total: 0,
        currentPage: 1
      },
      dialogType: {
        add: DIALOG_TYPE_ADD,
        update: DIALOG_TYPE_UPDATE
      },
      dialog: {
        dialogType: null,
        isShow: false,
        isLoading: false,
        form:
          {
            name: '',
            userId: '',
            majorDepartId: '',
          }
      },
      loadingDataVisible:false,
      rules: constantsRules.BasicInfoRules,
    }
  },
  mounted() {
    this.getAuth();
    this.queryData();
    this.getDepartments();
    //清除缓存页面信息
    this.$store.dispatch('clearEimsUser');
    this.$store.dispatch('clearEimsUserInfPapers');
    this.$store.dispatch('clearEimsUserInfPatents');
    this.$store.dispatch('clearEimsUserInfWorks');
    this.$store.dispatch('clearEimsUserInfAchis');
    this.$store.dispatch('clearEimsUserInfSubjects');
    this.$store.dispatch('clearEimsUserInfStudys');
    this.$store.dispatch('clearEimsUserInfTeachings');
    this.$store.dispatch('clearEimsUserInfGcps');
    this.$store.dispatch('clearEimsUserInfAwards');
    this.$store.dispatch('clearEimsUserInfAppointments');
    this.$store.dispatch('clearEimsUserInfHonors');
    this.$store.dispatch('clearEimsUserInfTalents');
    this.$store.dispatch('clearEimsUserInfTeachers');
    this.$store.dispatch('clearEimsUserInfGraduates');
    this.$store.dispatch('clearEimsUserInfMeetings');
    this.$store.dispatch('clearEimsUserInfTrainings');
    this.$store.dispatch('clearEimsUserInfStudios');
    this.$store.dispatch('clearEimsUserInfGuides');
    this.$store.dispatch('clearEimsUserInfCenters');
    this.$store.dispatch('clearEimsUserInfArticles');
    this.$store.dispatch('clearAllianceInfo');
    this.$store.dispatch('clearEimsUserInfLecture2s');
    this.$store.dispatch('clearEimsUserInfLectures');
    this.$store.dispatch('clearEimsUserInfQualitys');
    this.$store.dispatch('clearEimsUserInfVolunteers');
  },
  methods: {
    getAuth() {
      //调用方法之后获取权限设置在vuex中
      this.$store.dispatch("getUserPower").then(value => {
        //获取用户部门管理权限
        this.deptPower = this.$store.state.userPowerStore.deptPower
        this.superPower = this.$store.state.userPowerStore.superPower
      })
    },

    //查询
    handleQueryClick() {
      this.query.phone = this.form.phone;
      this.query.name = this.form.name;
      if (this.form.departmentId){
        this.query.departmentId= this.form.departmentId[this.form.departmentId.length - 1]
      }
      this.handlePageChange(1);
    },

    //分页
    handlePageChange(val) {
      this.data.currentPage = val;
      this.data.pageNum = val;
      this.queryData();
    },

    //查询部门id
    getDepartments(){
      let token = cookie.getCookie("token");
      http.post(window.config.api.baseUrl + '/eims-api/department/findCurrentAndSub', {
        token: token,
        data: {
          pageSize: -1
        }
      }).then(response => {
        this.departments = response.data.data.departments;
        //计算出医院的全id路径
        if (this.dialog.form.majorDepartId){
          let departIds = getCascaderFullValue(this.departments,this.dialog.form.majorDepartId);
          this.elementDeptId=departIds
        }
      })
    },

    //拿到弹窗的选择框选择的部门id
    handleDialogDeptChange(value) {
      if(value != null){
        this.elementDeptId = value;
        this.dialog.form.majorDepartId = value[value.length -1]
      }
    },

    handleDeptChange(value) {
      this.handleQueryClick()
    },

    //查询列表
    queryData() {
      let _this = this;
      _this.data.isLoading = true;
      let token = cookie.getCookie("token")
      http.post(window.config.api.baseUrl + '/eims-api/member/list', {
        token: token,
        data: {
          userId: this.query.phone,
          name: this.query.name,
          departmentId: this.query.departmentId,
          pageNum: this.data.pageNum,
        }
      }).then(response => {
        this.data.list = response.data.data.eimsUserList;
        this.data.total = response.data.data.total;
        _this.data.isLoading = false;
      })
    },

    //删除成员列表信息
    handleDeleteClick(row) {
      let _this = this;
      _this.$confirm('确定将' + row.name + '删除？',{
        confirmButtonText: "确定",
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() =>{
        _this.loadingDataVisible=true;
        let token = cookie.getCookie("token");
        http.post(window.config.api.baseUrl + '/eims-api/member/delete', {
          token: token,
          data: {
            userId: row.userId
          }
        }).then(response => {
          let status = response.data.code;
          if (status == '00000'){
            Message.success({message: "删除成功", showClose: true})
          }
          _this.queryData();
        }).finally(() =>{
          this.loadingDataVisible=false;
        })
      })
    },

    //查看成员信息
    handleViewClick(userId) {
      this.loadingDataVisible=true;
      // this.$store.dispatch("findMemberInfo",{userId}).then(response => {
      //   if (response.data.code == '00000'){
          this.$router.push({path: '/user/create',query:{"flag": "view",userId: userId}});
      //   }
      // }).finally(() => {
      //   this.loadingDataVisible=false;
      // })
    },

    //修改成员信息
    handleUpdateClick(userId) {
      // this.loadingDataVisible=true;

      // this.$store.dispatch("findMemberInfo",{userId}).then(response => {
      //   if (response.data.code == '00000'){
          this.$router.push({path: '/user/create',query:{"flag": "update", userId: userId}});
      //   }
      // }).finally(() => {
      //   this.loadingDataVisible=false;
      // })
    },

    //新增用户按钮
    handleAddClick() {
      this.dialog.dialogType = DIALOG_TYPE_ADD;
      this.dialog.isShow = true;
    },

      handleCommitDialog(){
      let that = this;
      //规则校验
      if (!that.validateDialogForm()) {
        return false;
      }
      let eimsUser = {
        userId: that.dialog.form.userId,
        name: that.dialog.form.name,
        //这个是为了保存到数据库使用的
        majorDepartId: that.elementDeptId[that.elementDeptId.length - 1] || this.dialog.form.majorDepartId,
        //这个是为了回显组件数据使用的
        elementDeptId: that.elementDeptId,
      }
      this.$store.dispatch("getBasicInfo", {"eimsUser": eimsUser, "eimsUserInfoBase": that.dialog.form});
      //提交数据
      let flag = "ADD";
      that.$store.dispatch("updateOrInsertMemberInfo",{flag}).then(value => {
        if(value.data.code == '00000'){
          Message.success({message:"保存成功", showClose: true});
          this.$store.dispatch("getEimsUser",{"userId": this.userId})
          this.$router.push({path: '/user/create', query: {"flag": "update", userId: that.dialog.form.userId}})
        }
      })
    },

    //规则校验
    validateDialogForm() {
      let result = false;
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          result = true;
        }
      });
      return result;
    },


    resetConditions() {
      Object.assign(this.$data.form, this.$options.data().form);
    },

    handleCloseDialog(){
      this.$refs['ruleForm'].resetFields();
      // this.dialog.form = {};
      Object.assign(this.$data.dialog.form, this.$options.data().dialog.form);
      this.dialog.isShow = false;
      this.elementDeptId = []
    },
  },

  created() {
    // this.getDepartments();
  },

  watch: {
    userPower() {
      this.deptPower = this.$store.state.userPowerStore.deptPower;
      this.superPower = this.$store.state.userPowerStore.superPower;
    }
  },

  computed: mapState({
    userPower: state => state.userPowerStore.userPower
  })
}
</script>


<style scoped>
.table-card {
  margin-top: 10px;

}

.header-card {
  padding-bottom: 20px;
  border-bottom: 1px solid #EBEEF5;
}

.el-dropdown-link {
  cursor: pointer;
}

.el-icon-more {
  font-size: 15px;
}

.identity-link:hover {
  transform:  rotate(90deg);
}

.identity-link {
  transform:  rotate(0deg);
  transition-duration: .5s;
}

</style>



// WEBPACK FOOTER //
// src/pages/member/MemberList.vue